define('controller/disclosure/disclosure.tab.controller',['require','exports','module','backbone.radio','fukit','fukit'],function(require, exports, module) {
  //prettier-ignore
  var Radio           = require('backbone.radio'),
      ROLES           = require('fukit').Roles,
      BaseController  = require('fukit').BaseController;

  //This is a template controller for all tabbed pages. Contains methods common to action buttons and sidebars. Tried storing common resources here but it broke things. TODO for another day...
  var DisclosureTabController = BaseController.extend({
    stateConfiguration: {
      defaults: {
        roles: [ROLES.COI_WEB_ACCESS],
      },
    },

    onStart: function() {
      //Listen for updates to the disclosure model and fetch outcome collection for a given state
      this.listenTo(this.getResource('disclosure'), 'sync', function(disclosureDetailModel) {
        var outcomeCollection = this.getResource('outcomeCollection');

        if (disclosureDetailModel.get('templateTypeDescription')) {
          outcomeCollection.urlParams({
            templateType: disclosureDetailModel.get('templateTypeDescription'),
          });
          outcomeCollection.fetch();
        }

        //there's no harm in having the availableReviewersCollection pre-fetched
        this.fetchResource('availableReviewersCollection');
      });

      //listen for updates to the required activities and update the workflowActivityStateModel accordingly.
      this.listenTo(
        this.getResource('disclosure.workflowTaskModel.requiredActivityCollection'),
        'update change:isComplete',
        function() {
          var workflowActivityStateModel = this.getResource('workflowActivityStateModel');
          var requiredActivityCollection = this.getResource('disclosure.workflowTaskModel.requiredActivityCollection');

          workflowActivityStateModel.set({
            areAllActivitiesComplete: Radio.request(
              'workflowActivityService',
              'areAllActivitiesComplete',
              requiredActivityCollection
            ),
          });
        }
      );

      //Check and see if is an existing previous reviewer, but we need the taskId from the workflowTaskModel first
      //We only need to initialize this model on page load, so we only need to listen once
      this.listenToOnce(this.getResource('disclosure.workflowTaskModel'), 'sync', function(model) {
        var previousReviewerModel = this.getResource('previousReviewerModel');

        //Don't try to fetch the previousReviewrModel if there are no tasks
        if (model.id) {
          previousReviewerModel.set({ taskId: model.id });
          previousReviewerModel.fetch();
        }
      });

      //listen for updates to the routing actions and flag when we have a 'pass to next reviewer' type action present,
      //and store the model for future reference
      this.listenTo(
        this.getResource('disclosure.workflowTaskModel.formDataModel.routingActionCollection'),
        'update',
        function(routingActionCollection) {
          var workflowActivityStateModel = this.getResource('workflowActivityStateModel');
          var passActionModel = routingActionCollection.filter(function(model) {
            var routingId = model.get('routingId');

            //'YES' and 'REVIEWER' are the routingId's associated with the "Pass to reviewer" action buttons
            return routingId === 'REVIEWER' || routingId === 'YES';
          });

          //there should only ever be one of the "pass to reviewer" actions returned, so we take the first one.
          //otherwise, set the value to null explicitly so BindAndFormatOptionValuesBehavior will notice the event
          passActionModel = passActionModel.length > 0 ? passActionModel[0] : null;

          workflowActivityStateModel.set({ passActionModel: passActionModel });
        }
      );

      this.listenTo(this.getResource('routingHistoryCollection'), 'sync', function(collection) {
        var completedHistoryModel = this.getResource('completedHistoryModel');
        var historyModel = collection.filter(function(model) {
          return String(model.get('routingOption')).indexOf('Disclosure resolved:') !== -1;
        });

        if (historyModel.length > 0) {
          completedHistoryModel.set(historyModel[0].attributes);
          completedHistoryModel.trigger('sync', completedHistoryModel);
        }
      });
    },

    onClose: function() {
      this.stopListening();
    },
  });

  module.exports = DisclosureTabController;
});

